<template>
  <div class="estimate-detail">
    <LableContent
      label="估算明细"
      class="gusuan-detail"
      hasCollapse
      showFullScreen
      height="450px"
      bottomPadding="0px"
    >
      <TabBtn
        ref="tabBtnRef"
        :tabs="tabs"
        :active-tab="tabActive"
        @tab-click="initData"
        height="100%"
      >
        <template slot="btn">
          <el-button type="primary" size="mini" @click="handleGlobalEstimate">
            全局估算
          </el-button>
          <!-- <el-button type="primary" size="mini" @click="handleEstimateAdjustment">
          估算调价
        </el-button> -->
        </template>
        <template>
          <SimpleTable
            ref="topTable"
            :menus="menus"
            :columns="columns.top"
            :data="tableData.top"
            table-code="EstimateDetailTop"
            :loading="loading.top"
            @row-select="onRowSelectTop"
            @modify-data-change="onModifyDataChangeTop"
          />
        </template>
      </TabBtn>
    </LableContent>

    <LableContent
      label="历史数据"
      v-if="currentTab.value === 'pie-project-unit-cost'"
      class="gusuan-detail"
      hasCollapse
      showFullScreen
      height="450px"
      bottomPadding="0px"
    >
      <SimpleTable
        ref="bottomTable"
        :menus="['查询', '插入', '批量删除', '批量修改']"
        :menusMergeAfter="menusMergeAfterBottom"
        :columns="columns.bottom"
        :data="tableData.bottom"
        table-code="EstimateDetailBottom"
        :loading="loading.bottom"
        :bottomFrozenRowCount="1"
        @modify-data-change="onModifyDataChangeBottom"
      />
    </LableContent>

    <LableContent
      label="动态估算"
      class="gusuan-detail"
      hasCollapse
      showFullScreen
      height="350px"
      topPadding="0px"
    >
      <div class="left-right-box1" :style="{ height: '100%' }">
        <SimpleTable
          width="70%"
          ref="leftTable"
          :columns="columns.left"
          :data="tableData.left"
          table-code="EstimateDetailLeft"
          :loading="loading.left"
        />
        <SimpleTable
          width="calc(30% - 11px)"
          ref="rightTable"
          :menus="['查询', '上传', '批量删除']"
          :columns="columns.right"
          :data="tableData.right"
          table-code="EstimateDetailRight"
          :loading="loading.right"
          :uploadParams="uploadParams"
          @cell-dblclick="handleCellDblclickRight"
        />
      </div>
    </LableContent>

    <SelectBaseAmountDialog
      ref="SelectBaseAmountDialog"
      @confirm="handleSelectBaseAmountDialogConfirm"
    />
    <HistoryProjectDialog
      ref="HistoryProjectDialog"
      @confirm="handleInsertHistoryConfirm"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import TabBtn from '@/components/TabBtn/index.vue'
import SelectBaseAmountDialog from './SelectBaseAmountDialog.vue'
import HistoryProjectDialog from './HistoryProjectDialog.vue'
import { tabs } from './config'
import { sortRecords, addCbFn, preViewFile } from '@/utils/index'
import LableContent from '@/components/LableContent/index.vue'
export default {
  name: 'EstimateDetail',
  components: {
    SimpleTable,
    TabBtn,
    SelectBaseAmountDialog,
    HistoryProjectDialog,
    LableContent
  },
  inject: ['detailsVm'],
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tabs,
      tabActive: tabs[0].value,
      currentTab: null,

      columns: {
        top: [],
        bottom: [],
        left: [],
        right: []
      },
      tableData: {
        top: [],
        bottom: [],
        left: [],
        right: []
      },
      loading: {
        top: false,
        bottom: false,
        left: false,
        right: false
      },
      currentSelect: {
        top: null,
        bottom: null,
        left: null,
        right: null
      },
      uploadParams: {
        id: '',
        accept: '',
        uploadAfter: () => this.uploadAfter()
      }
    }
  },
  computed: {
    menus() {
      if (
        ['common-cash-flow', 'common-investment-estimate'].includes(
          this.currentTab.value
        )
      ) {
        return ['查询']
      } else if (this.currentTab.value === 'pie-project-unit-cost') {
        return ['查询', '插入', '批量修改', '批量删除']
      }
      return ['查询', '插入', '批量修改', '批量删除', '选中模板', '保存模板']
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      if (this.$refs.tabBtnRef) this.$refs.tabBtnRef.active = tabs[0].value
      for (const element of tabs) {
        const arr = [
          'common-land-cost',
          'common-charging-items',
          'common-sale-cost',
          'common-finance-cost',
          'common-ops-cost',
          'common-ops-income',
          'common-sale-income'
        ]
        if (arr.includes(element.value)) {
          const obj = element.columns.top.find(e => e.field === 'baseAmount')
          obj.handleEdit = this.handleEditBillBaseAmount
        }
      }

      this.initData(this.tabs.find(item => item.value === this.tabActive))
    },

    initData(currentTab) {
      this.currentTab = currentTab

      this.columns.top = currentTab.columns.top
      this.columns.bottom = currentTab.columns.bottom
      this.columns.left = currentTab.columns.left
      this.columns.right = currentTab.columns.right

      this.getTable('top', currentTab.value)
    },
    async getTable(type, code, isLocal = true) {
      this.tableData[type] = []
      this.tableData.left = []
      this.tableData.right = []
      this.loading[type] = true
      const res = await this.$service.get(`/${code}/list`, {
        mainId: this.basicInfo.id
      })
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
      if (res.data?.length && isLocal) this.$refs[type + 'Table'].initialized()
    },

    async getBottomTable(type = 'bottom') {
      this.tableData[type] = []
      this.loading[type] = true
      const res = await this.$service.get(`/pie-budget-history-data/list`, {
        itemId: this.currentSelect.top?.id
      })
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
    },

    // 查时间分布
    async getLeftTable(type = 'left') {
      this.tableData[type] = []
      if (!this.currentSelect.top?.id) return
      this.loading[type] = true
      const res = await this.$service.get(`/common-time-distribution/list`, {
        oieId: this.basicInfo.id,
        itemId: this.currentSelect.top?.id
      })
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
    },
    async getRightTable(type = 'right') {
      this.tableData[type] = []
      if (!this.currentSelect.top?.id) return
      this.loading[type] = true
      const res = await this.$service.get(
        `/business-file/list/${this.currentSelect.top?.id}`
      )
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
    },

    onRowSelectTop(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      if (this.currentSelect.top?.id === obj?.id) return
      this.currentSelect.top = obj
      this.uploadParams.id = obj?.id

      this.getBottomTable()
      this.getLeftTable()
      this.getRightTable()
    },

    onModifyDataChangeTop(getModifyData, cleanModifyData) {
      addCbFn(
        this.$service,
        `/${this.currentTab.value}/batch`,
        getModifyData,
        cleanModifyData,
        arr => arr.map(e => ({ ...e, mainId: this.basicInfo.id }))
      )
    },

    async onModifyDataChangeBottom(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        `/pie-budget-history-data/batch`,
        getModifyData,
        cleanModifyData,
        arr =>
          arr.map(e => ({
            ...e,
            mainId: this.basicInfo.id,
            itemId: this.currentSelect.top?.id,
            budgetHistoryDataId: e.id
          }))
      )
      this.getTable('top', this.currentTab.value, false)
      this.getBottomTable('bottom', false)
    },

    async uploadAfter() {
      this.getRightTable()
    },

    menusMergeAfterBottom(contextMenuMap) {
      contextMenuMap['插入'] = () => this.handleInsertHistory()
    },

    handleInsertHistory() {
      if (!this.currentSelect.top?.id) {
        return this.$message.warning('请选择一个单项工程')
      }
      this.$refs.HistoryProjectDialog.show({
        oieId: this.basicInfo.id
      })
    },

    handleInsertHistoryConfirm(records) {
      records.forEach(row => {
        row.bhdId = row.id
        row.id = undefined
        row.adjustPriceCoefficient = 1
        row.costBudgetIndicatorActual = row.totalCostIndicator
      })
      const arr = records.map(row => {
        return {
          ...row,
          costBudget: row.totalCost,
          costBudgetIndicator: row.totalCostIndicator
        }
      })
      const index = this.$refs.bottomTable.handleInsert(arr)
    },

    // 全局估算
    async handleGlobalEstimate() {
      this.detailsVm.loadingContainer = true
      const res = await this.$service.post(
        `/plan-investment-estimate/global-estimate/${this.basicInfo.id}`,
        {
          oieId: this.basicInfo.id
        }
      )
      this.detailsVm.loadingContainer = false
      if (res?.code === 200) {
        this.$message.success('操作成功')
        this.init()
        this.detailsVm.getBaseInfo(this.basicInfo.id)
      }
    },

    // 估算调价
    handleEstimateAdjustment() {},

    // 取费基数编辑
    handleEditBillBaseAmount(selectedCellInfos) {
      if (selectedCellInfos.length !== 1)
        return this.$message.warning('只能修改一条数据！')
      this.$refs.SelectBaseAmountDialog.show({
        id: this.basicInfo.id,
        selectedCellInfos: selectedCellInfos
      })
    },

    // 取费基数编辑确认
    handleSelectBaseAmountDialogConfirm(selectedCellInfos, str) {
      selectedCellInfos.forEach(cells => {
        const obj = cells[0].originData
        this.$set(obj, 'baseAmount', str)
        this.$refs.topTable.modifyData.set(obj, obj)
      })
    },

    handleCellDblclickRight(args) {
      preViewFile(args.originData?.path)
    }
  }
}
</script>

<style scoped lang="less">
.estimate-detail {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
  ::v-deep .tab-btn .table {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    > div {
      flex: 1;
      height: 33% !important;
    }
  }

  .top-table {
    height: 300px;
  }

  .bottom-table {
    height: 300px;
  }

  .left-right-box1 {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>
